import styled from "styled-components";

export const LevelContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  height: 450px;
  width: 600px;
  position: relative;
  border-radius: 10px;
  cursor: pointer;
  background: ${(props) =>
    props.mode ? "rgba(210, 229, 255, 0.11)" : "#131415"};
  @media screen and (max-width: 768px) and (min-width: 500px) {
    transform: scale(0.7, 0.7);
  }
  @media screen and (max-width: 500px) and (min-width: 300px) {
    height: 600px;
    width: 450px;
    transform: scale(0.5, 0.5);
  }
  @media screen and (max-width: 300px) {
    transform: scale(0.1, 0.1);
  }
  .skull-div {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 150px;
    width: 150px;
    background: ${(props) => (props.mode ? "#131415" : "white")};
  }
  @keyframes blink {
    0% {
      opacity: 0;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0;
    }
  }
  img {
    z-index: 50;
    height: 120px;
    user-select: none;
  }
  .top-left-dot {
    position: absolute;
    background: ${(props) => (props.mode ? "#131415" : "white")};
    width: 10px;
    height: 10px;
    left: 0;
    top: 0;
  }
  .bottom-left-dot {
    position: absolute;
    background: ${(props) => (props.mode ? "#131415" : "white")};
    height: 10px;
    width: 10px;
    left: 0;
    bottom: 0;
  }
  .top-right-dot {
    position: absolute;
    background: ${(props) => (props.mode ? "#131415" : "white")};
    height: 10px;
    width: 10px;

    right: 0;
    top: 0;
  }
  .bottom-right-dot {
    position: absolute;
    background: ${(props) => (props.mode ? "#131415" : "white")};
    height: 10px;
    width: 10px;

    right: 0;
    bottom: 0;
  }
`;
